export const STATUS_OPTED_IN = 'OPTED_IN';
export const STATUS_NOT_SENT = 'NOT_SENT';
export const STATUS_SENT = 'SENT';

export const ERROR_EMAIL_ALREADY_EXIST = 'EMAIL_ALREADY_EXIST';
